function SectionHeader({ label, title, subtitle, centered = false, subtitleStyle }) {
  const titleStyle = centered
    ? {
        textAlign: 'center',
        marginBottom: subtitle ? undefined : '60px',
      }
    : undefined;
  const descriptionStyle = centered
    ? { textAlign: 'center', marginLeft: 'auto', marginRight: 'auto', ...subtitleStyle }
    : subtitleStyle;

  return (
    <>
      {label ? (
        <div className="section-label" style={centered ? { textAlign: 'center' } : undefined}>
          {label}
        </div>
      ) : null}
      <h2 className="section-title" style={titleStyle}>
        {title}
      </h2>
      {subtitle ? (
        <p className="section-sub" style={descriptionStyle}>
          {subtitle}
        </p>
      ) : null}
    </>
  );
}

export default SectionHeader;
